var map = {
	"./brochure_01.png": 1330,
	"./brochure_02.png": 49513,
	"./doc_01.png": 98174,
	"./doc_02.png": 34901,
	"./whitepaper_01.png": 57431,
	"./whitepaper_02.png": 33500,
	"./whitepaper_03.png": 69413,
	"./whitepaper_04.png": 98986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89084;